import { useEffect, useMemo, useState } from 'react';

enum EEventDataType {
  Resize = 'resize',
}

interface IResizeEventData {
  type: EEventDataType.Resize;
  payload: number;
}

type TFrameMessageEventData = IResizeEventData;

export const useFrameEvents = () => {
  const [frameHeight, setFrameHeight] = useState(0);

  useEffect(() => {
    const handleFrameMessage = (event: MessageEvent<TFrameMessageEventData>) => {
      if (event.data.type === EEventDataType.Resize) {
        const newHeight = event.data.payload;

        setFrameHeight(newHeight);
      }
    };

    window.addEventListener('message', handleFrameMessage);

    return () => {
      window.removeEventListener('message', handleFrameMessage);
    };
  }, []);

  return useMemo(() => ({ frameHeight }), [frameHeight]);
};
